// extracted by mini-css-extract-plugin
module.exports = {"Messages":"Messages_Messages__2D-Ym","Sentinel":"Messages_Sentinel__286rc"};